import {Component} from "react";
import {Button, Col, Divider,
    Form, FormInstance, Input,
    Layout,
    message,
    Modal,
    Popconfirm, Row,
    Space, Spin,
    Table,
    Typography
} from "antd";
import AxiosUtil from "../../utils/AxiosUtil";
import NavHeader from "../../components/NavHeader";
import SiderMenuMain from "../../components/SiderMenuMain";
import NavBreadcrumb from "../../components/NavBreadcrumb";
import NavFooter from "../../components/NavFooter";
import React from "react";
import {SettingOutlined, FormOutlined, DeleteOutlined, PlusCircleOutlined, RedoOutlined} from "@ant-design/icons";
import moment from "moment";

const {Content} = Layout;

interface IProps {
    match:any
}

export default class Param extends Component<IProps> {
    formRef = React.createRef<FormInstance>();

    state = {
        loadingData: false,
        loadingUser: false,

        showEdit: false,
        settingUserId: 0,
        settingUserName: '',
        settingUserRole: [],
        mainData: [],
        roleData: [],
        selectedRows: [],

        pageIndex: 1,
        pageSize: 20,
        total: 0,

        rtype: this.props.match.params.rtype || 2,
    }

    componentDidMount() {
        this.loadRole();
        this.loadMainData(this.props.match.params.rtype || 2);
    }

    componentWillReceiveProps(nextProps: any) {
        let key = nextProps.match.params.rtype || 2;
        this.loadMainData(key);
        this.setState({
            rtype: key
        });
    }

    render() {

        const crumb = [
            {name: '系统管理'},
            {name: '人员管理'},
        ];

        const columns = [
            {
                title: 'ID',
                key: 'user_id',
                dataIndex: 'user_id',
                align: 'center' as 'center',
                width: 1,
            },
            {
                title: '登录名',
                key: 'login_name',
                dataIndex: 'login_name',
                width: 100,
                sorter: {compare: (a: any, b: any) => a.login_name.localeCompare(b.login_name)},
                defaultSortOrder: 'ascend' as 'ascend',
            },
            {
                title: '姓名',
                key: 'user_name',
                dataIndex: 'user_name',
                width: 100,
                sorter: {compare: (a: any, b: any) => a.user_name.localeCompare(b.user_name)}
            },
            {
                title: '编辑',
                key: 'operation',
                dataIndex: 'operation',
                width: 100,
                align: 'center' as 'center',
                render: (_: any, record: any) => {
                    return (
                        record.login_name === "admin" ? <></> :
                        <Space size="small" split={<Divider type="vertical"/>}>
                            <Typography.Link onClick={() => this.showEdit(record)}
                                             key={'edit' + record.user_id}><FormOutlined/></Typography.Link>
                            <Popconfirm title="确定要删除这个用户吗"
                                        okText="删除"
                                        cancelText
                                        onConfirm={() => this.deleteRecord(record.user_id)}
                            >
                                <Typography.Link key={'del' + record.user_id}><DeleteOutlined/></Typography.Link>
                            </Popconfirm>
                        </Space>
                    )
                }
            },
            {
                title: '最近登录',
                key: 'last_login',
                dataIndex: 'last_login',
                width: 100,
                sorter: {compare: (a: any, b: any) => a.last_login - b.last_login},
                render: (text: any) => {
                    return text === null ? '' : moment(text).format('yyyy-MM-DD HH:mm')
                }
            },
            {
                title: '登录IP',
                key: 'last_ip',
                dataIndex: 'last_ip',
                width: 100,
            },
            {
                title: '更新日期',
                key: 'update_time',
                dataIndex: 'update_time',
                width: 100,
                render: (text: any) => {
                    return text === null ? '' : moment(text).format('yyyy-MM-DD HH:mm')
                }
            },
        ];
        const rolsColumns = [
            {title: 'ID', key: 'role_id', dataIndex: 'role_id',},
            {title: '角色', key: 'role_name', dataIndex: 'role_name',},
            {title: '类型', key: 'role_type_name', dataIndex: 'role_type_name',},
            {title: '备注', key: 'remark', dataIndex: 'remark',},
        ]
        const onFinishAiForm = () => {
        }
        const {selectedRows} = this.state;
        const rowSelection = {
            selectedRowKeys: selectedRows,
            onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                this.setState({selectedRows: selectedRowKeys});
            },
            getCheckboxProps: (record: any) => ({
                disabled: record.name === 'Disabled User', // Column configuration not to be checked
                name: record.name,
            }),
        };
        return (
            <Layout>
                <NavHeader/>
                <Content className={"main-body"}>
                    <Layout>
                        <SiderMenuMain/>
                        <Content className={'main-content'}>
                            <NavBreadcrumb itemList={crumb}/>
                            <div id="mainTable">
                                <Space size={16} style={{marginBottom: 16}}>
                                    <Button type="primary" key='showEdit'
                                            onClick={() => this.showEdit(null)}><PlusCircleOutlined/> 新增</Button>
                                    <Button type="primary" key='reload'
                                            onClick={(e) => this.loadMainData()}><RedoOutlined/> 刷新</Button>
                                </Space>
                                <Table key='user'
                                       rowKey='user_id'
                                       columns={columns}
                                       dataSource={this.state.mainData}
                                       size="small"
                                       bordered
                                       // pagination={{pageSize: 20}}
                                       pagination={{ onChange: this.pagiChange, total: this.state.total, pageSize: this.state.pageSize, current: this.state.pageIndex}}
                                />
                            </div>

                            <Modal title={<div><SettingOutlined/> 编辑用户：<Button
                                type='link'>{this.state.settingUserName}</Button></div>}
                                   key='editUser'
                                   visible={this.state.showEdit}
                                   onOk={this.saveRecord}
                                   onCancel={this.hideEdit}
                                   forceRender={true}
                                   centered>
                                <div id="">
                                    <Spin tip="Loading..." size="large" spinning={this.state.loadingUser}>
                                        <Form name="AiReport_Form" layout="horizontal" autoComplete="off" key='ff123'
                                              onFinish={onFinishAiForm}
                                              labelCol={{span: 4, offset: 0}}
                                              ref={this.formRef}>
                                            <Form.Item key='a1' hidden name={'user_id'} initialValue=''><Input/></Form.Item>
                                            <Form.Item key='a2' hidden name={'updated'} initialValue=''><Input/></Form.Item>
                                            <Row gutter={[0, 0]} key="r">

                                                <Col span={24}>
                                                    <Form.Item name={'login_name'} initialValue='' label={'登录名'}
                                                               style={{margin: 8}}
                                                               rules={[{required: true, message: '请输入登录名'}]}>
                                                        <Input placeholder={'请输入登录名'}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item name={'user_name'} initialValue='' label={'真实姓名'}
                                                               style={{margin: 8}}
                                                               rules={[{required: true, message: '请输入真实姓名'}]}>
                                                        <Input placeholder={'请输入真实姓名'}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item name={'setPwd'} initialValue='' label={'重置密码'}
                                                               style={{margin: 8}}>
                                                        <Input.Password placeholder={'如无需修改请保持空白'}
                                                                        autoComplete="new-password"/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item name={'user_email'} initialValue='' label={'Email'}
                                                               style={{margin: 8}}>
                                                        <Input placeholder={'请输入Email'}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={24}>
                                                    <Form.Item name={'user_mobile'} initialValue='' label={'手机号'}
                                                               style={{margin: 8}}>
                                                        <Input placeholder={'请输入手机号'}/>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </Form>
                                        <Table key="role"
                                               size='small'
                                               rowKey="role_id"
                                               pagination={false}
                                               columns={rolsColumns}
                                               dataSource={this.state.roleData}
                                               rowSelection={{type: 'checkbox', ...rowSelection}}
                                               bordered
                                        />
                                    </Spin>
                                </div>
                            </Modal>
                        </Content>
                    </Layout>
                </Content>
                <NavFooter/>
            </Layout>
        );
    }

    showEdit = (record: any) => {
        if (record) {
            const callback = (suc: boolean, dat: any) => {
                if (suc) {
                    console.log(suc, dat);
                    this.setState({selectedRows: dat});
                }
            }
            AxiosUtil.AxiosRequest('/api/user/getrole', {user_id: record.user_id}, callback);
            this.formRef.current!.setFieldsValue(record);
            this.setState({
                settingUserId: record.user_id,
                settingUserName: record.user_name,
                showEdit: true
            })
        } else {
            this.formRef.current!.resetFields();
            this.setState({
                settingUserId: 0,
                settingUserName: '',
                showEdit: true
            })
        }
    }
    hideEdit = () => {
        this.setState({showEdit: false})
    }
    saveRecord = () => {
        console.log('form:', this.formRef.current!.getFieldsValue());
        console.log('role:', this.state.selectedRows.toString());
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                message.success({content: '保存成功！', className: 'message_success'});
                this.setState({showEdit: false})
                this.loadMainData();
            }
        }
        const values = this.formRef.current!.getFieldsValue();
        const roles = this.state.selectedRows;
        if (roles.length === 0) {
            message.error({content: '请选择用户角色！', className: 'message_error'});
            return;
        }
        const post = {...values, updated: roles};
        AxiosUtil.AxiosRequest('/api/user/setInfo', post, callback);
    }
    deleteRecord = (record_key: string) => {
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                message.success({content: '用户已删除！', className: 'message_success'});
                this.loadMainData();
            }
        }
        AxiosUtil.AxiosRequest('/api/user/deleteUser', {delete: record_key}, callback);
    }
    loadRole = () => {
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({roleData: dat.list});
            }
        }
        AxiosUtil.AxiosRequest('/api/role/list', {}, callback);
    }

    loadMainData = (key?: number) => {
        const rtype = key || this.state.rtype;
        const callback = (suc: boolean, dat: any) => {
            if (suc) {
                this.setState({
                    mainData: dat.list,
                    total: dat.total
                });
            }
        }
        AxiosUtil.AxiosRequest('/api/user/getUser', {
            rtype: rtype,
            pageSize: this.state.pageSize,
            pageIndex: this.state.pageIndex
        }, callback);
    }
    // 分页页码或每页条数发生变化时调用该函数重新请求数据
    pagiChange = async (page:number, pageSize?:number) => {
        if(this.state.pageSize === pageSize){
            await this.setState({pageIndex: page})
        } else {
            await this.setState({pageIndex: 1, pageSize: pageSize as number})
        }
        // await (this.state.pageSize === pageSize)
        // ? this.setState({pageIndex: page})
        // : this.setState({pageIndex: 1, pageSize: pageSize as number})
        this.loadMainData();
    }
}


